import axios from "axios";

// Default to local FastAPI, but allow Env Var override
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

export const postBetaSubmission = async (data) => {
  try {
    // Attempt to hit the real backend
    const response = await axios.post(`${API_BASE}/beta/submit`, data, {
      headers: { 'Content-Type': 'application/json' },
      timeout: 5000 // 5s timeout
    });
    return response.data;
  } catch (error) {
    console.warn("Backend connection failed or timed out. Switching to simulation mode for UI demo.");
    
    // FALLBACK SIMULATION (So the UI doesn't break during demos)
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, message: "Simulation: Data captured locally." });
      }, 1500);
    });
  }
};

export const subscribeNewsletter = async (email) => {
  // Placeholder for future newsletter endpoint
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true });
    }, 1000);
  });
};
